import { createReducer } from '@reduxjs/toolkit';
import { setSelectedHistoryOrder } from './actions';

interface HistoryState {
  selectedOrder: any | null;
}

const initialState: HistoryState = {
  selectedOrder: null,
};

const historyReducer = createReducer(initialState, (builder) => {
  builder.addCase(setSelectedHistoryOrder, (state, action) => {
    state.selectedOrder = action.payload;
  });
});

export default historyReducer;
